export const hoursRegex = /^[0-2][0-9]:[0-5][0-9]$/
export const isValidTime = (time: string) => {
  return hoursRegex.test(time)
}
